var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.606 5.58199L16 8.99199V2.03198L10.606 5.58199Z",
    fill: "#BA43B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.03198V8.99599L5.394 5.58598L0 2.03198Z",
    fill: "#BA43B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H1.00003C0.763188 0.00202821 0.534955 0.0890689 0.356912 0.24527C0.178869 0.401471 0.0628632 0.616434 0.0300293 0.850998L8.00003 6.1L15.97 0.848999C15.9368 0.614799 15.8206 0.40031 15.6426 0.244514C15.4646 0.0887185 15.2366 0.00195804 15 0Z",
    fill: "#BA43B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69003 6.18604L8.27503 7.11804C8.19339 7.17181 8.09778 7.20047 8.00003 7.20047C7.90228 7.20047 7.80667 7.17181 7.72503 7.11804L6.30803 6.18506L0.0300293 10.156C0.0639489 10.3892 0.180213 10.6024 0.357775 10.7573C0.535337 10.9121 0.76246 10.9982 0.998029 11H14.998C15.2336 10.9982 15.4607 10.9121 15.6383 10.7573C15.8158 10.6024 15.9321 10.3892 15.966 10.156L9.69003 6.18604Z",
    fill: "#BA43B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.1e0ea29cd40f4ebd1eb0d420c1dc0f07.svg";
export { ForwardRef as ReactComponent };